import React, { useContext } from 'react';

import CreateTournamentContext from '../../CreateTournament/CreateTournamentContext/CreateTournamentContext';
import BaseHeader from '../BaseHeader/BaseHeader';

import styles from './Header.scss';

interface Props {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
}

/* This Header is used in HomeGames Modals only */
const Header: React.FC<Props> = ({ title = null, subTitle }) => {
  const {
    state: { isRecurrenceOpen }
  } = useContext(CreateTournamentContext);

  return (
    <BaseHeader
      headerClassName={styles.header}
      title={title}
      subTitle={subTitle && <span>{subTitle}</span>}
      hideCloseButton={isRecurrenceOpen}
    />
  );
};

export default Header;
